import { Activity } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { SpaceHubResponse } from "@/api";
import { SectionEmpty } from "@/components/section";
import { ActivityList } from "../ActivityList";
import { SpaceSection } from "./SpaceSection";

export function ActivitySection({ space }: Readonly<{ space: SpaceHubResponse }>) {
  const { t } = useTranslation("spaces", { keyPrefix: "detail.activity" });
  const items = (space.activities ?? []).slice(0, 6);
  return (
    <SpaceSection title={t("title")}>
      {items.length === 0 ? (
        <SectionEmpty icon={<Activity size={18} />} hint={t("empty")} />
      ) : (
        <ActivityList items={items} />
      )}
    </SpaceSection>
  );
}
